const _ = require('lodash');

function assignShopperDetails(details) {
    this.IsGuest = !details || details.IsGuest;

    _.assign(this, details);

    return this;
}

function assignShopperPreferences(preferences) {
    this.preferences = {
        EnableAccessibleOptions: preferences ? preferences.EnableAccessibleMenu : false,
    };

    _.assign(this.preferences, preferences);

    return this;
}

function assignShopperLocation(details) {
    this.location = {};

    if (details) {
        _.assign(this.location, details.Location);
    }

    return this;
}

function assignShopperAdditionalDetails(details) {
    _.assign(this, details);
    this.shopperAnalytics.push(this);
    return this;
}

function ShopperService(Restangular, bootstrap, shopperAnalytics) {
    this._api = Restangular.one('shopper');
    this._myAccountApi = Restangular.one('myaccount');
    this.shopperAnalytics = shopperAnalytics;
    assignShopperDetails.call(this, bootstrap.getBootstrappedData(bootstrap.bootstrapped.Shopper));
    assignShopperPreferences.call(this, bootstrap.getBootstrappedData(bootstrap.bootstrapped.ShopperPreferences));
    assignShopperLocation.call(this, bootstrap.getBootstrappedData(bootstrap.bootstrapped.ShopperDetails));
    assignShopperAdditionalDetails.call(this, bootstrap.getBootstrappedData(bootstrap.bootstrapped.ShopperDetails));
}

ShopperService.prototype.getCurrentShopperDetails = function () {
    return this._api.one('detail').get().then(details => assignShopperAdditionalDetails.call(this, details));
};

ShopperService.prototype.getCurrentShopper = function () {
    return this._api.get().then(assignShopperDetails.bind(this));
};

ShopperService.prototype.getBasicShopperPreferences = function () {
    return this._myAccountApi.one('BasicShopperPreferences').get().then(assignShopperPreferences.bind(this));
};

ShopperService.prototype.getCurrentShopperPreferences = function () {
    return this._myAccountApi.one('ShopperPreferences').get();
};

ShopperService.prototype.updateShopperPersonalDetails = function (shopper) {
    return this._myAccountApi.one('PersonalDetails').doPOST(shopper).then(details => assignShopperAdditionalDetails.call(this, details));
};

ShopperService.prototype.updateShopperBusinessDetails = function (shopper) {
    return this._myAccountApi.one('BusinessDetails').doPOST(shopper).then(details => assignShopperAdditionalDetails.call(this, details));
};

ShopperService.prototype.getDeliveryPassesSummary = function () {
    return this._myAccountApi.one('DeliveryPasses').get();
};

ShopperService.prototype.shouldDisplayDeliveryPassNavLink = function () {
    return this._myAccountApi.one('DeliverySaverNavLinkEnabled').get();
};

ShopperService.prototype.setPreferenceEnableAccessibility = function (newValue) {
    return this._myAccountApi.one('ShopperPreferences/EnableAccessibleMenu').doPOST({ Value: newValue });
};

ShopperService.prototype.getAuthenticationMethod = function () {
    return this._api.one('AuthenticationMethod').get();
};

module.exports = ShopperService;



// WEBPACK FOOTER //
// ./src/auth/shopper/shopper.service.js